import { render, staticRenderFns } from "./AddCapitalSupplier.vue?vue&type=template&id=f5d6f81e&scoped=true&"
import script from "./AddCapitalSupplier.vue?vue&type=script&lang=js&"
export * from "./AddCapitalSupplier.vue?vue&type=script&lang=js&"
import style0 from "./AddCapitalSupplier.vue?vue&type=style&index=0&id=f5d6f81e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d6f81e",
  null
  
)

export default component.exports